
import 'components/ckeditor.tag'
import 'components/loader.tag'
riot.tag2('brand-edit', '  <loader if="{loader}"></loader>\n  <virtual hide="{loader}">\n    <div class="btn-group"><a class="btn btn-default" href="#products/brands"><i class="fa fa-chevron-left"></i></a>\n      <button class="btn {item._edit_ ? &quot;btn-success&quot; : &quot;btn-default&quot;}" if="{checkPermission(&quot;products&quot;, &quot;0010&quot;)}" onclick="{submit}" type="button"><i class="fa fa-floppy-o"></i> Сохранить</button>\n      <button class="btn btn-default" onclick="{reload}" title="Обновить" type="button"><i class="fa fa-refresh"></i></button>\n    </div>\n    <div class="h4">{item.name || \'Редактирование бренда\'}</div>\n    <ul class="nav nav-tabs m-b-2">\n      <li class="active"><a data-toggle="tab" href="#brand-edit-home">Основная информация</a></li>\n      <li><a data-toggle="tab" href="#brand-edit-seo">SEO</a></li>\n    </ul>\n    <form action="" onchange="{change}" onkeyup="{change}" method="POST">\n      <div class="tab-content">\n        <div class="tab-pane fade in active" id="brand-edit-home">\n          <div class="row">\n            <div class="col-md-2">\n              <div class="form-group">\n                <div class="well well-sm">\n                  <image-select name="imageFile" section="shopbrand" alt="0" size="256" value="{item.imageFile}"></image-select>\n                </div>\n              </div>\n            </div>\n            <div class="col-md-10">\n              <div class="row">\n                <div class="col-md-12">\n                  <div class="form-group {has-error: error.name}">\n                    <label class="control-label">Наименование</label>\n                    <input class="form-control" name="name" type="text" value="{item.name}">\n                    <div class="help-block">{error.name}</div>\n                  </div>\n                </div>\n                <div class="col-md-12">\n                  <div class="form-group">\n                    <label class="control-label">URL страницы</label>\n                    <input class="form-control" name="code" type="text" value="{item.code}">\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Краткое описание</label>\n                <ckeditor name="description" value="{item.description}"></ckeditor>\n              </div>\n            </div>\n          </div>\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Подробное описание</label>\n                <ckeditor name="content" value="{item.content}" style="min-height: 500px;"></ckeditor>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="tab-pane fade" id="brand-edit-seo">\n          <div class="row">\n            <div class="col-md-12">\n              <div class="form-group">\n                <label class="control-label">Заголовок</label>\n                <input class="form-control" name="seoHeader" type="text" value="{item.seoHeader}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Ключевые слова</label>\n                <input class="form-control" name="seoKeywords" type="text" value="{item.seoKeywords}">\n              </div>\n              <div class="form-group">\n                <label class="control-label">Описание</label>\n                <textarea class="form-control" rows="5" name="seoDescription" style="min-width: 100%; max-width: 100%;" value="{item.seoDescription}"></textarea>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </form>\n  </virtual>\n', '', '', function(opts) {
'use strict';

var self = this;

self.item = {};
self.loader = false;
self.error = false;
self.mixin('permissions');
self.mixin('validation');
self.mixin('change');

self.rules = {
    name: 'empty'
};

self.afterChange = function (e) {
    self.error = self.validation.validate(self.item, self.rules, e.target.name);
};

self.submit = function (e) {
    var params = self.item;
    self.error = self.validation.validate(params, self.rules);

    if (!self.error) {
        API.request({
            object: 'Brand',
            method: 'Save',
            data: params,
            success: function success(response) {
                popups.create({ title: 'Успех!', text: 'Бренд сохранен!', style: 'popup-success' });
                observable.trigger('brands-reload');
            }
        });
    }
};

self.reload = function () {
    observable.trigger('brands-edit', self.item.id);
};

observable.on('brands-edit', function (id) {
    self.loader = true;
    self.error = false;
    var params = { id: id };

    API.request({
        object: 'Brand',
        method: 'Info',
        data: params,
        success: function success(response) {
            self.item = response;
            self.loader = false;
            self.update();
        },
        error: function error(response) {
            self.item = {};
            self.loader = false;
            self.update();
        }
    });
});

self.on('update', function () {
    localStorage.setItem('SE_section', 'shopbrand');
});

self.on('mount', function () {
    riot.route.exec();
});
});


// WEBPACK FOOTER //
// ./pages/products/brands/brand-edit.tag